import type { Ref } from 'react';
import { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import { ClickAwayListener } from '@mui/material';
import type { PopperProps } from '@mui/material/Popper';
import Popper from '@mui/material/Popper';
import PopupState, { bindToggle, bindPopper } from 'material-ui-popup-state';
import type { PopupState as PopupStateProps } from 'material-ui-popup-state/hooks';
import { PopperMenu, PopperMenuItem } from '@trinity/chat-components/components/Popper/index.js';
import { useAppSelector } from '@/store';
import { useSelectWorkspaces } from '@/store/selectors';
import { getLocationFor } from '@trinity/chat-components';
//import { useSelectWorkspaces } from '@containers/Store';

type MenuProps = {
  onClose: () => unknown;
};

const WorkspacesContextMenu = forwardRef(({ onClose }: MenuProps, ref: Ref<HTMLDivElement>) => {
  const workspaces = useSelectWorkspaces();

  return (
    <PopperMenu ref={ref}>
      <Link to={getLocationFor.workspaces.root({ workspace: 'personal' })} onClick={onClose}>
        <PopperMenuItem>
          {workspaces.personal.object.name}
        </PopperMenuItem>
      </Link>
      <Link to={getLocationFor.workspaces.root({ workspace: 'group' })} onClick={onClose}>
        <PopperMenuItem>
          {workspaces.group.object.name}
        </PopperMenuItem>
      </Link>
      <Link to={getLocationFor.workspaces.root({ workspace: 'shared' })} onClick={onClose}>
        <PopperMenuItem>
          Shared
        </PopperMenuItem>
      </Link>
    </PopperMenu>
  );
});

export type WorkspacesMenuPopperProps = {
  renderAnchor: (state: PopupStateProps) => React.ReactNode;
} & Pick<PopperProps, 'placement'>;

export const WorkspacesContextMenuPopper = ({
  placement = 'bottom-start',
  renderAnchor,
}: WorkspacesMenuPopperProps) => {

  return (
    <PopupState variant="popper" popupId="workspaces-popper">
      {popupState => (
        <div>
          <div {...bindToggle(popupState)}>
            {renderAnchor(popupState)}
          </div>
          <Popper
            {...bindPopper(popupState)}
            placement={placement}
            style={{ zIndex: 2 }}>
            <ClickAwayListener
              onClickAway={() => popupState.close()}>
              <WorkspacesContextMenu
                onClose={popupState.close} />
            </ClickAwayListener>
          </Popper>
        </div>
      )}
    </PopupState>
  );
};
